import React from "react";
import { Box, IconButton, Skeleton, Typography } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import type { InvitePlatform } from "./inviteTypes";
import { platformLabel } from "./inviteCopy";
import { inviteTextBoldSx, inviteTextSx } from "./inviteTypography";

export interface InviteLinkedAccountRowProps {
  platform: InvitePlatform;
  username?: string;
  accountId?: string;
  profileUrl?: string;
  loading?: boolean;
}

export const InviteLinkedAccountRow: React.FC<InviteLinkedAccountRowProps> = ({
  platform,
  username,
  accountId,
  profileUrl,
  loading = false,
}) => {
  if (loading) {
    return <Skeleton variant="text" width={200} sx={{ mx: "auto" }} />;
  }

  const displayName = username || accountId;
  if (!displayName) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
      }}
    >
      <Typography variant="body2" sx={inviteTextSx}>
        {platformLabel(platform)}:{" "}
        <Box component="span" sx={inviteTextBoldSx}>
          {displayName}
        </Box>
      </Typography>
      {profileUrl && (
        <IconButton
          size="small"
          component="a"
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ p: 0.25, color: "text.primary" }}
        >
          <OpenInNew sx={{ fontSize: 12 }} />
        </IconButton>
      )}
    </Box>
  );
};

export default InviteLinkedAccountRow;
